@if (Endoscope) {
<div class="container-fluid mt-3 ">
    <div class="row rounded-1 background-light mb-3 py-3">
        <div class="col fw-bold text-center mb-3">
            Liste des PSV
        </div>
        <div class="row">
            @for (sp of getUniquePSV(); track sp) {
            <div class="col-6 text-center">
                {{sp.Name}}
            </div>
            }
        </div>
    </div>
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Endoscope
        </span>
    </div>
    <div class="row rounded-1 background-light mb-3 py-3">
        <mat-form-field class="col-12">
            <mat-label>Heure de prelevement</mat-label>
            <input matInput placeholder="Heure de prelevement" [ngxTimepicker]="timepicker1" [format]="24" [value]="TimeSampling" readonly>
            @if (TimeSampling) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearSampling()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker1 (timeSet)="timeSetSampling($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Num Serie</mat-label>
            <input matInput [(ngModel)]="Endoscope.NumSerie" placeholder="Num Serie">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Num Appareil</mat-label>
            <input matInput [(ngModel)]="Endoscope.NumAppareil" placeholder="Num Appareil">
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Marque</mat-label>
            <mat-select placeholder="Marque" [(ngModel)]="Endoscope.Marque" required>
                @for (o of MarqueList; track o; let i = $index) {
                <mat-option [value]="o">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Modele</mat-label>
            <input matInput [(ngModel)]="Endoscope.Modele" placeholder="Modele">
        </mat-form-field>
        <!-- 
        <mat-form-field class="col-12">
            <mat-label>Type d'endoscope</mat-label>
            <mat-select placeholder="Type d'endoscope" [(ngModel)]="Endoscope.TypeEndoscope" required>
                @for (o of TypeEndoscopeList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field> -->

        <mat-form-field>
            <mat-label>Type d'endoscope</mat-label>
            <input type="text"
                   placeholder="Type d'endoscope"
                   aria-label="Type d'endoscope"
                   matInput
                   [matAutocomplete]="auto"
                   [(ngModel)]="SearchEndoscopeText"
                   (keyup)="filterEndoscopeList()">
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="onSelectionChange($event)">
                @for (option of filteredEndoscopeOptions ; track option) {
                <mat-option [value]="option">{{option.s}}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <!-- <mat-form-field class="col-12">
            <mat-label>Motif de Prélèvement</mat-label>
            <mat-select placeholder="Motif de Prélèvement" [(ngModel)]="Endoscope.MotifPrelevement" required>
                @for (o of MotifPrelevementList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field> -->

        <mat-form-field>
            <mat-label>Motif de Prélèvement</mat-label>
            <input type="text"
                   placeholder="Motif de Prélèvement"
                   aria-label="Motif de Prélèvement"
                   matInput
                   [matAutocomplete]="auto1"
                   [(ngModel)]="SearchMotifText"
                   (keyup)="filterMotifList()">
            <mat-autocomplete #auto1="matAutocomplete" (optionSelected)="onMotifSelectionChange($event)">
                @for (option of filteredMotifOptions; track option) {
                <mat-option [value]="option">{{option.s}}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Date de traitement en lavage</mat-label>
            <input matInput placeholder="Date de traitement en lavage" [matDatepicker]="picker" [(ngModel)]="DateDerniereLavage" (click)="picker.open()"
                   (dateChange)="dateDernierLavageChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col-12">
            <mat-label>Heure de traitement en lave</mat-label>
            <input matInput placeholder="Heure de traitement en lave" [ngxTimepicker]="timepicker2" [format]="24" [value]="TimeBionettoyage" readonly>
            @if (TimeBionettoyage) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearBionettoyage()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker2 (timeSet)="timeSetBionettoyage($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Traitement</mat-label>
            <mat-select placeholder="Traitement" [(ngModel)]="Endoscope.Traitement" required>
                @for (o of TraitementList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <!-- <mat-form-field class="col-12">
            <mat-select placeholder="Cycle Traitement" [(ngModel)]="Endoscope.CycleTraitement" required>
                @for (o of CycleTraitementList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field> -->

        <mat-form-field class="col-12">
            <mat-label>Type Eau Rincage</mat-label>
            <mat-select placeholder="Type Eau Rincage" [(ngModel)]="Endoscope.TypeEauRincage" required>
                @for (o of TypeEauRincageList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Condition de prélèvement</mat-label>
            <mat-select placeholder="Condition de prélèvement" [(ngModel)]="Endoscope.ConditionPrelevement" required>
                @for (o of ConditionPrelevementList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <!-- <mat-form-field class="col-12">
            <mat-label>Condition de stockage</mat-label>
            <mat-select placeholder="Condition de stockage" [(ngModel)]="Endoscope.ConditionStockage" required>
                @for (o of ConditionStockageList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field> -->

        <mat-form-field>
            <mat-label>Condition de stockage</mat-label>
            <input type="text"
                   placeholder="Condition de stockage"
                   aria-label="Condition de stockage"
                   matInput
                   [matAutocomplete]="auto2"
                   [(ngModel)]="SearchConditionStockageText"
                   (keyup)="filterConditionStockageList()">
            <mat-autocomplete #auto2="matAutocomplete" (optionSelected)="onConditionStockageSelectionChange($event)">
                @for (option of filteredConditionStockageOptions; track option) {
                <mat-option [value]="option">{{option.s}}</mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>

        @if (Endoscope.ConditionStockage === EConditionStockage.StockageESET) {
        <mat-form-field class="col-6">
            <mat-label>Date de stockage</mat-label>
            <input matInput placeholder="Date de stockage" [matDatepicker]="picker2" [(ngModel)]="DateStockage" (click)="picker2.open()"
                   (dateChange)="dateStockageChanged($event)">
            <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <mat-form-field class="col-6">
            <mat-label>Heure de stockage</mat-label>
            <input matInput placeholder="Heure de stockage" [ngxTimepicker]="timepicker3" [format]="24" [value]="TimeStockage" readonly>
            @if (TimeStockage) {
            <button matSuffix mat-icon-button aria-label="Clear" (click)="clearStockage()">
                <mat-icon class="material-symbols-outlined">close</mat-icon>
            </button>
            }
            <ngx-material-timepicker #timepicker3 (timeSet)="timeStockage($event)" [defaultTime]="DefaultTime"></ngx-material-timepicker>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Numero ESET</mat-label>
            <input matInput [(ngModel)]="Endoscope.NumeroESET" placeholder="Numero ESET">
        </mat-form-field>
        }
    </div>
    <div class="row">
        <span class="ms-3 display-6 fw-bold">
            Canaux
        </span>
    </div>
    @for (prel of Endoscope.CanalEndoscopeList; track prel; let j = $index) {
    <span>
        <div class="row rounded-1 background-light mb-3 py-3">
            <div class="text-center fw-bold mb-3">
                {{prel.Prelevement.SamplingPoint.Name}}
            </div>
            @if (prel.Prelevement.Comment) {
            <div class="text-center fst-italic mb-3">
                {{prel.Prelevement.Comment}}
            </div>
            }
            <mat-form-field class="col-12">
                <mat-label>Code OGI</mat-label>
                <input matInput [(ngModel)]="prel.Prelevement.OgiCode" placeholder="Code OGI" readonly>
            </mat-form-field>

            <mat-form-field class="col-12">
                <mat-label>Portée</mat-label>
                <mat-select placeholder="Portée" [(ngModel)]="prel.Portee" required>
                    @for (o of PorteeList; track o; let i = $index) {
                    <mat-option [value]="i + 1">
                        <span>{{o}}</span>
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
            <!-- <mat-form-field class="col-12">
                <input matInput type="number" [(ngModel)]="prel.Portee" placeholder="Portée  (mmol/L)">
            </mat-form-field> -->
            <mat-form-field class="col-12">
                <mat-label>Volume Liquide Injecté (ml/L)</mat-label>
                <input matInput type="number" [(ngModel)]="prel.VolumeLiquideInjecte" placeholder="Volume Liquide Injecté (ml/L)">
            </mat-form-field>
            <!-- <mat-form-field class="col-12">
                    <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3" cdkAutosizeMaxRows="3"
                              [(ngModel)]="prel.Observations"
                              placeholder="Observation"></textarea>
                </mat-form-field> -->
        </div>
        <div class="row">
            <span class="ms-5 fw-bold">
                Flacons
            </span>
        </div>
        @if (prel.Prelevement.FlaconList.length > 0) {
        <div class="row rounded-1 mb-3 py-3 background-light">
            <div class="col-12">
                @for (flacon of prel.Prelevement.FlaconList; track flacon; let i = $index) {
                <div class="row">
                    <div class="col-6">{{flacon.Code}}</div>
                    <div class="col-6">{{getFlaskTypeLabel(flacon.Type)}}</div>

                    <button class="col-auto" matPrefix mat-icon-button aria-label="barcode">
                        <mat-icon class="material-symbols-outlined">qr_code_scanner</mat-icon>
                    </button>
                    <mat-form-field class="col">
                        <mat-label>Barcode</mat-label>
                        <input matInput [(ngModel)]="flacon.Barcode" placeholder="Barcode" (keydown)="checkBarCode($event, flacon.Barcode)" [id]="'barcode'+EServiceType.Endoscope+'-'+j+'-'+i"
                               (keyup)="checkBarCodeExistence(flacon.Code) ; focusNext(flacon.Barcode, j, i, EServiceType.Endoscope, prel.Prelevement.FlaconList.length)" [readonly]="canBeDisabled(flacon)">

                        @if (flacon.Barcode) {
                        <button matSuffix mat-icon-button aria-label="Clear" (click)="flacon.Barcode=''">
                            <mat-icon class="material-symbols-outlined">close</mat-icon>
                        </button>
                        }
                    </mat-form-field>
                </div>
                }
            </div>
        </div>
        }
        <!-- <div class="row">
            <span class="ms-5 fw-bold">
                Consommables
            </span>
        </div> -->
        <!-- <div class="row mb-3">
            <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button
                    (throttledClick)="openConsommableBox(EServiceType.Dialyse, prel.Prelevement)">
                <mat-icon class="material-symbols-outlined">add</mat-icon>Ajouter
            </button>
        </div> -->
        <!-- @if (prel.Prelevement.ConsommableList.length > 0) {
        <div class="row ">
            <div class="col-12">
                @for (cons of prel.Prelevement.ConsommableList; track cons; let i = $index) {
                <div class="row rounded-1 mb-3 py-3 background-light">
                    <div class="col-4 text-end">Type</div>
                    <div class="col-8"> {{getConsommableEndoscopeLabel(cons.Type)}}</div>
                    <div class="col-4 text-end">Numéro Lot</div>
                    <div class="col-8 ">{{cons.NumeroLot}}</div>
                    <div class="col-4 text-end">Expiration</div>
                    <div class="col-8">{{cons.Expiration!.toLocaleString()}}</div>
                    <div class="col-12 text-end">
                        <button appPreventDoubleClick class="" color="primary" mat-icon-button
                                (throttledClick)="openConsommableBox(EServiceType.Dialyse, prel.Prelevement, cons)">
                            <mat-icon class="material-symbols-outlined">edit</mat-icon>
                        </button>
                        <button appPreventDoubleClick class="" color="warn" mat-icon-button (throttledClick)="deleteConsommable(cons, prel.Prelevement)">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                        </button>
                    </div>
                </div>
                }
            </div>
        </div>
        } -->
    </span>
    }
    @if (Intervention?.Status !== EInterventionStatus.Preview) {
    <div class="row mb-3">
        <button appPreventDoubleClick class="col-12" color="primary" mat-raised-button (throttledClick)="showAlert(false)">
            Enregistrer
        </button>
    </div>
    <div class="row mb-3">
        <button appPreventDoubleClick class="col-12" color="accent" mat-raised-button (throttledClick)="showAlert(true)">
            Terminer et Enregistrer
        </button>
    </div>
    }
</div>
}